module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "holder"
  }, [_c('div', {
    staticClass: "contacts_block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.content[_vm.lang]['CONTACT_INFORMATION']))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.content[_vm.lang]['ADDRESS_1']))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.content[_vm.lang]['ADDRESS_2']))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "menu_block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['SOLUTIONS']))]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/platform'
    }
  }, [_vm._v("GL Enterprise Platform")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/cloud-credit'
    }
  }, [_vm._v("Cloud Credit")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/bid-pro'
    }
  }, [_vm._v("Bid PRO")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/loyalty'
    }
  }, [_vm._v("Loyalty")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/global-centre'
    }
  }, [_vm._v("Global Centre")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/resource-management'
    }
  }, [_vm._v("Resource Management")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/aspa'
    }
  }, [_vm._v("ASPA")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu_block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['SERVICES']))]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/services/engineering'
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['DESIGN']))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/services/development'
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['DEVELOPMENT']))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/services/consulting'
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['CONSULTING']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu_block"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/news'
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['PRESS_CENTER']))])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/company/about'
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['COMPANY']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("© 2014-" + _vm._s(_vm.getCurrentYear()) + ", " + _vm._s(_vm.content[_vm.lang]['OOO_GRACE_LOGIC']))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "tel:+78435280548"
    }
  }, [_vm._v("+7 (843) 528-05-48")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "email"
  }, [_c('a', {
    attrs: {
      "href": "mailto:office@gracelogic.com"
    }
  }, [_vm._v("office@gracelogic.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29551c42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VFooter.vue
// module id = 113
// module chunks = 2